import { useEffect, useState } from 'react';

const hasWidgetLoaded = (): boolean =>
	typeof window !== 'undefined' && !!window.$jarabot?.hasLoaded;

export function useJarabotWidgetReady(): boolean {
	const [isReady, setIsReady] = useState(hasWidgetLoaded);

	useEffect(() => {
		if (isReady) return undefined;

		const onReady = (): void => setIsReady(true);
		window.addEventListener('jarabot:ready', onReady, { once: true });
		return () => window.removeEventListener('jarabot:ready', onReady);
	}, [isReady]);

	return isReady;
}
